/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Divider, FormInstance, Row, Select } from 'antd'
import { isNumber } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, CustomTextInput, FormLabels, CustomTag, CustomText, CustomSelect } from 'src/components'
import { filterSaleOfferProject, resetFilterProjectOfferState, saleOffferFilterProjectSelector } from 'src/features'

const ProjectSaleOfferSelector: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, notFound, data: projectFiltered } = useAppSelector(saleOffferFilterProjectSelector)

  const handleProjectInputChange = (value: string) => {
    dispatch(resetFilterProjectOfferState())
    form.resetFields(['vintage_year'])
    if (!value) { return }
    const filterType = isNumber(value) ? 'id' : 'name'
    dispatch(filterSaleOfferProject(value, filterType))
  }

  const projectTag = {
    LOADING: { type: 'processing', label: t('SalesOffer.FilterProject') },
    ERROR: { type: 'error', label: t('SalesOffer.NotFound') },
    FILTERED: { type: 'success', label: projectFiltered?.name }
  }[loading ? 'LOADING' : notFound ? 'ERROR' : projectFiltered && 'FILTERED'] || null

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('SalesOffer.ProjectOffer')}
        subtitle={t('SalesOffer.Filter')}
      />
    </CustomCol>
    <CustomCol>
      <CustomTextInput
        name='project'
        placeholder={t('SalesOffer.ProjectPlaceHolder')}
        onChange={(e) => handleProjectInputChange(e.target.value)}
        required
      />

      {/* Filter Tags */}
      {projectTag && <>
        <CustomTag type={projectTag.type} text={projectTag.label} />
        <Divider />
      </>}

      {/* Vintage Years */}
      {projectFiltered?.vintage_years?.length > 0 && <>
        <CustomText label={t('SalesOffer.SelectVintage')} />
        <CustomSelect
          name='vintage_year'
          placeholder={t('Projects.YearPlaceholder')}
          required
        >
          {projectFiltered.vintage_years.map(y => <Select.Option key={y} value={y}>{y}</Select.Option>)}
        </CustomSelect>
      </>}
    </CustomCol>
  </Row>
}

export default ProjectSaleOfferSelector
